import { render, staticRenderFns } from "./StandardNavigationItem.vue?vue&type=template&id=4d401cdb"
import script from "./StandardNavigationItem.vue?vue&type=script&lang=ts"
export * from "./StandardNavigationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports